import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';
import store from '../index';
import CategoryService from '../../common/api/category.service';


@Module({ dynamic: true, store, name: 'category' })
class CategoryModule extends VuexModule {
    categories: Array<any> = [];

    service = new CategoryService();

    @Mutation
    SET_ALL_CATEGORIES(category: any) {
      this.categories = category;
    }

    @Action
    async fetchCategories(): Promise<void> {
      const response = await this.service.fetchAllCategories();
      if (!response) { return; }
      const { categories } = response.data.data;
      this.SET_ALL_CATEGORIES(categories);
    }
}

export default getModule(CategoryModule);
